import { JsBridge } from "./JsBridge";

// Native 页面 pageName 枚举
export enum NativePageName {
  DirectoryPage = "directory_page",
  CollectionDetailPage = "collection_detail_page",
  DeerPictureBookSeriesPage = "deer_picture_book_series_page",
  PictureBookDetailPage = "picture_book_detail_page",
  DirectoryDetailPage = "directory_detail_page",
  MoerduoPlayerDetailPage = "moerduo_player_detail_page",
  VideoPlayPage = "video_play_page",
  HomePage = "home",
  DlnaControllerPage = "dlna_controller_page",
  PractiseSentenceFillMainPage = "practise_sentence_fill_main_page",
  PractiseWordsCardMainPage = "practise_words_card_page",
  PractiseWordsMainPage = "practise_words_main_page",
  PractiseWordsSinglePage = "practise_words_single_page",
  PractiseReadingComprehensionPage = "practise_reading_comprehension_page",
  WebPage = "web_page",
  DeerLoginPage = "deer_login_page",
  UpdateWordPage = "update_word_page",
  UpdateDirectoryMediaPage = "update_directory_media_page",
  UpdateDirectoryPage = "update_directory_page",
  FavoritePage = "favorite_page",
  PlanTaskPage = "plan_task_page",
  SelectPictureBookPage = "select_picture_book_page",
  MyWorksPage = "my_works_page",
  MyFinishedWorksPageWithGroup = "my_finished_works_page_with_group",
  CollectionAddContentPage = "collection_add_content_page",
  CalendarPage = "calendar_page",
  ModifyWordPlanPage = "modify_word_plan_page",
  UnitLearningPage = "unit_learning_page",
  BookSelectionPage = "book_selection_page",
  WordStudyPage = "word_study_page",
  WordDetailPage = "word_detail_page",
  MyWordBooksPage = "my_word_books_page",
  WordTrainingDetailPage = "word_training_detail_page",
  WordPrintSelectPage = "word_print_select_page",
  WordPrintSelectUnitPage = "word_print_select_unit_page",
  WordPrintFormatPage = "word_print_format_page",
  WordPrintPage = "word_print_page",
  TranslationMainPage = "translation_main_page",
  WordMatchPage = "word_match_page",
  DictationExercisePage = "dictation_exercise_page",
  WordPlayPage = "word_play_page",
  UserWordBooksPage = "user_word_books_page",
  BookUnitsPage = "book_units_page",
  AddWordPage = "add_word_page",
  SearchWordPage = "search_word_page",
  BookListPage = "book_list_page",
  PhoneticPage = "phonetic_page",
  PhonicsLinkagePage = "phonics_linkage_page",
  UnitPracticePage = "unit_practice_page",
  WordElimination = "word_elimination_page",
  PictureBookTabPage = "picture_book_tab_page",
  SpellWordsMainPage = "spell_words_main_page",
  AiWordCreateMainPage = "ai_word_create_main_page",
  DictationCheckPage = "dictation_check_page",
  PictureBookPrintPage = "picture_book_print_page",
  WordAiCreateTextSelectUnitPage = "word_ai_create_text_select_unit_page",
  CreatePictureBookPage = "create_picture_book_page",
  PictureBookQuickInputPage = "picture_book_quick_input_page",
  PictureBookPdfUploadPage = "picture_book_pdf_upload_page",
  ShowImgPage = "show_img_page",
  EbbinghausDetailPage = "ebbinghaus_detail_page",
  AlbumPage = "album_page",
  InputMethodBottomSheet = "input_method_bottom_sheet",
  LetterStudyPage = "letter_study_page",
}

// 打开专辑列表 create_picture_book_page
export function openAlbumList(isGo: boolean) {
    const params = JSON.stringify({
        pageName: NativePageName.CreatePictureBookPage,
        extra: {
            isGo,
        },
    });
  JsBridge.openPage(params);
}


interface IOpenPictureBookQuickInputPage {
    albumId: number;
    bookId?: number; // 编辑某一个绘本的时候传入
    albumTitle: string;
}

// 打开拍照生产绘本页面 create_picture_book_page
export function openPictureBookQuickInputPage({albumId, bookId, albumTitle}: IOpenPictureBookQuickInputPage) {
    const params = JSON.stringify({
        pageName: NativePageName.PictureBookQuickInputPage,
        extra: {
            albumId,
            bookId,
            albumTitle,
        },
    });
    JsBridge.openPage(params);
}

// 打开PDF上传页面 create_picture_book_page
export function openPictureBookPdfUploadPage({albumId, albumTitle}: IOpenPictureBookQuickInputPage) {
    const params = JSON.stringify({
        pageName: NativePageName.PictureBookPdfUploadPage,
        extra: {
            albumId,
            albumTitle,
        },
    });
    JsBridge.openPage(params);
}

// 打开绘本详情页 picture_book_detail_page
export function openPictureBookDetailPage(bookId: number) {
    const params = JSON.stringify({
        pageName: NativePageName.PictureBookDetailPage,
        extra: {
            bookId
        },
    });
    JsBridge.openPage(params);
}

// 打开自助创建绘本方法选择列表
export function openUpdateListBottomSheet() {
    const params = JSON.stringify({
        pageName: NativePageName.InputMethodBottomSheet,
    });
    JsBridge.openPage(params);
}

// 打开字母学习页
export function openLetterStudyPage(letterList: string[], initialIndex: number = 0) {
    const params = JSON.stringify({
        pageName: NativePageName.LetterStudyPage,
        extra: {
            letterList,
            initialIndex,
        },
    });
    JsBridge.openPage(params);
}

export function openPhoneticPage(initialPhonetic: string, pronunciationType: number) {
    const params = JSON.stringify({
        pageName: NativePageName.PhoneticPage,
        extra: {
            initialPhonetic,
            pronunciationType,
        },
    });
    JsBridge.openPage(params);
}

// 打开目录页面
export function openDirectoryPage(directoryModel: any) {
    const params = JSON.stringify({
        pageName: NativePageName.DirectoryPage,
        extra: {
            directoryModel,
        },
    });
    JsBridge.openPage(params);
}

// 打开收藏详情页面
export function openCollectionDetailPage(collectionId: number) {
    const params = JSON.stringify({
        pageName: NativePageName.CollectionDetailPage,
        extra: {
            collectionId,
        },
    });
    JsBridge.openPage(params);
}

export function openWordStudyPage(words: Array<{wordId: number, word: string}>, initialIndex: number = 0) {
    const wordList = words.map(w => ({
        wordId: w.wordId,
        word: w.word,
    }));
    const params = JSON.stringify({
        pageName: NativePageName.WordStudyPage,
        extra: {
            wordList,
            initialIndex,
        },
    });
    JsBridge.openPage(params);
}